
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ajin-button-fab',
    templateUrl: './button.component.html',
    encapsulation: ViewEncapsulation.None
})

export class  ButtonFabComponent {
    @Input() label: string | null = null;
    @Input() icon: string | null = null;
    @Input() color: string | null = null;
    @Input() disabled: boolean = false;

    @Output() click = new EventEmitter<void>();

    constructor( ) {
    }


}


